import type { CollectedEmail } from '../../../domain/meeting';
import type { EventDataChanged } from '../../../domain/message';
import DataExtractionService from '../../dataExtraction/DataExtractionService';
import ScrappingMonitoringService from '../../scrapingMonitoring/scrappingMonitoringService';

type GmailHandlerCommands = {
  setHomePage: () => void;
  setEmailPage: () => void;
  setCollectedEmail: (email: CollectedEmail) => void;
  getState: () => { isOpen: boolean };
};

const handleIframeLoad = (commands: GmailHandlerCommands): void => {
  commands.setHomePage();
};

const handleDataChange = (commands: GmailHandlerCommands, event: EventDataChanged, url?: URL): void => {
  const newEmailData = DataExtractionService.gmail.extractNewEmailData(event.data);
  const { recipientsDomains, recipientsEmails, subject } = newEmailData;
  const emailData = DataExtractionService.gmail.extractEmailData(event.data);
  const replyToEmailData = DataExtractionService.gmail.extractReplyToEmail(event.data);

  let collectedInfo: CollectedEmail = { ...emailData };

  const isEmptyNewEmail = !recipientsDomains?.length && !recipientsEmails?.length && !subject;

  if (commands.getState().isOpen && !isEmptyNewEmail) {
    ScrappingMonitoringService.dispatchScrappingEvent({ data: collectedInfo, url });
  }

  if (recipientsDomains?.length > 0) {
    collectedInfo = {
      recipientsDomains,
      recipientsEmails,
      subject,
    };
  }

  if (replyToEmailData?.recipientsDomains?.length > 0) {
    collectedInfo = {
      ...collectedInfo,
      replyToDomains: replyToEmailData.recipientsDomains,
      replyToEmails: replyToEmailData.recipientsEmails,
    };
  }

  if (collectedInfo?.recipientsDomains?.length || collectedInfo?.senderDomains?.length) {
    commands.setEmailPage();
    if ('instanceId' in event && typeof event.instanceId === 'string') {
      collectedInfo = { ...collectedInfo, instanceId: event.instanceId };
    }
    commands.setCollectedEmail(collectedInfo);
  } else {
    commands.setHomePage();
  }
};

export const gmailMessageHandler = {
  handleIframeLoad,
  handleDataChange,
};
